@if (!seminarsLoading) {
  <app-filter
    id="filterMenu"
    [isOpen]="filterMenuOpen"
    [filters]="filters"
    [data]="seminars"
    (filterMenuOpenChange)="filterMenuOpen = $event"
    (filteredData)="onFilteredData($event)"
    (filterChange)="onFiltersChange($event)"></app-filter>
}
<div class="flex-c gap-24">
  @if (showSearch) {
    <div class="search-container">
      <div class="search-container-content">
        <input
          type="text"
          name="search"
          placeholder="Hier suchen..."
          [(ngModel)]="searchQuery"
          (input)="applySearch()" />
        <button
          id="filterMenuButton"
          class="inwi-icon-text-button-medium-outline"
          (click)="filterMenuOpen = !filterMenuOpen">
          <div class="button-content">
            <div class="button-icon">
              <i class="fa-regular fa-filter"></i>
            </div>
            <div class="button-text">Filter</div>
          </div>
        </button>
      </div>
    </div>
  }
  <div class="course-card-container">
    @if (seminarsLoading) {
      @for (item of [].constructor(3); track $index) {
        <p-skeleton borderRadius="12px" height="465px" />
      }
    } @else {
      @if (searchedAndFilteredSeminars.length > 0) {
        @for (seminarDateSeries of searchedAndFilteredSeminars; track $index) {
          <app-topic-card
            [topicCard]="getTopicCardValues(seminarDateSeries)"
            (buttonClicked)="onCourseClick(seminarDateSeries)"></app-topic-card>
        }
      }
    }
  </div>
  @if (searchedAndFilteredSeminars.length === 0) {
    <div class="flex-r gap-8 align-center align-self-stretch justify-center">
      <i class="fa-regular fa-book-copy"></i>
      <span>
        Es gibt keine Seminare, die mit deinen Suchkriterien übereinstimmen.
      </span>
    </div>
  }
</div>
